import React from "react";
import type { LucideIcon } from "lucide-react";
import { Card, CardContent, EmptyState } from "@/components/ds";

// A titled dashboard panel that renders either its children or a built-in empty state.
export function SectionCard({
  title, icon: Icon, action, isEmpty, emptyIcon, emptyTitle, emptyDescription, emptyAction, children, testid,
}: {
  title: string;
  icon?: LucideIcon;
  action?: React.ReactNode;
  isEmpty?: boolean;
  emptyIcon?: LucideIcon;
  emptyTitle?: string;
  emptyDescription?: string;
  emptyAction?: React.ReactNode;
  children?: React.ReactNode;
  testid?: string;
}) {
  return (
    <Card data-testid={testid}>
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
        <div className="flex items-center gap-2.5">
          {Icon && (
            <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-slate-100 text-slate-500">
              <Icon className="h-4 w-4" />
            </span>
          )}
          <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
        </div>
        {action}
      </div>
      <CardContent className="p-0">
        {isEmpty ? (
          <div className="px-5 py-10">
            <EmptyState icon={emptyIcon} title={emptyTitle ?? "Nothing yet"} description={emptyDescription} action={emptyAction} />
          </div>
        ) : (
          children
        )}
      </CardContent>
    </Card>
  );
}
